import { useEffect, useState } from 'react';

export default function InputText({
  label,
  inputId,
  placeholder,
  value = '',
  setValue = '',
  required = false,
  isValid,
  setIsValid = () => {},
  inputMode = 'text',
  customType,
  externalError = '',
}) {
  const [validText, setValidText] = useState('');

  useEffect(() => {
    // 숫자 타입(price)은 0도 유효한 값으로 처리
    const isEmpty =
      customType === 'price'
        ? value === '' || value === null || value === undefined
        : !value;

    if (required && isEmpty) {
      setValidText('필수 입력 값입니다.');
      return;
    }

    setValidText('');
  }, [required, value, customType]);

  // 외부에서 주입된 에러 메시지 (제출 시 강제 표시)
  const displayError = externalError || validText;
  const hasError = !!displayError;

  return (
    <div className="w-full flex justify-between items-center mb-2">
      <label htmlFor={inputId} className="w-1/5 text-explorer font-semibold text-base">
        {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
      </label>
      <input
        id={inputId}
        type="text"
        inputMode={inputMode}
        placeholder={placeholder}
        className={`w-3/5 rounded-lg py-1 px-3 ${hasError ? 'border-2 border-red-500' : ''}`}
        value={value}
        onChange={async (e) => {
          const textValue = customType === 'price' ? e.target.value.trim() : e.target.value;

          if (customType === 'price' && Number.isNaN(+textValue)) {
            return alert('가격은 숫자만 입력 가능합니다. 숫자만 입력해주세요.');
          }

          setValue(textValue);

          // 숫자 타입은 문자열이 비어있지 않으면 유효
          const isEmpty =
            customType === 'price'
              ? textValue === ''
              : !textValue.trim();

          setIsValid(!isEmpty);
        }}
      />
      <span className="ml-4 w-1/5 text-red-400 text-sm">{displayError}</span>
    </div>
  );
}
